import React, { Suspense, useEffect } from "react";
import loadable from "@loadable/component";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import {PersistGate} from 'redux-persist/lib/integration/react';
import eccoTheme from "./eccoTheme";
import { LoadingIndicatorProvider } from "./contexts/LoadingIndicator";
import SimpleRoute from "./Container/SimpleRoute";
import store, {persistor} from "./redux/store";
import { Provider } from "react-redux";
import PanelRoute from "./Container/PanelRoute";
import LoginRoute from "./Container/LoginRoute";
import LoadingIndicator from "./components/LoadingIndicator";
/* import {FCM} from "@capacitor-community/fcm"; */
import {Capacitor} from "@capacitor/core";
import AppUrlListener from './AppUrlListener';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

const Login = loadable(() => import('./routes/login'), {
    fallback: <LoadingIndicator />
});

const RecoverAccount = loadable(() => import('./routes/recoverAccount'), {
    fallback: <LoadingIndicator />
});

const Registration = loadable(() => import('./routes/registration'), {
    fallback: <LoadingIndicator />
});

const PasswordAssignment = loadable(() => import('./routes/passwordAssignment'), {
    fallback: <LoadingIndicator />
});

const Profile = loadable(() => import('./routes/profile'), {
    fallback: <LoadingIndicator />
});

const RedirectRegistration = loadable(() => import('./routes/redirectRegistration'), {
    fallback: <LoadingIndicator />
});

/* if(Capacitor.platform !== 'web') { */
// Enable the auto initialization of the library
    /* FCM.setAutoInit({enabled: true}).then(() => console.log(`Auto init enabled`)); */

// Check the auto initialization status
  /*   FCM.isAutoInitEnabled().then((r) => {
        console.log('Auto init is ' + (r.enabled ? 'enabled' : 'disabled'));
    });
} */


const App = () => {

    useEffect(() => { 
        if (Capacitor.getPlatform() === "web") {    
          FirebaseAnalytics.initializeFirebase({
              apiKey: "AIzaSyABDgMSHUFS4qmqV9nQWMO934iYQYzTK1A",
              authDomain: "ecco-app-ind.firebaseapp.com",
              projectId: "ecco-app-ind",
              storageBucket: "ecco-app-ind.appspot.com",
              messagingSenderId: "427622805521",
              appId: "1:427622805521:web:e8bf9d692ddf046b5981b0",
              measurementId: "G-28YR2N4KV3",
          }); 
      }
    }, []);

    return <Provider store={store}>
        <ThemeProvider theme={eccoTheme}>
            <LoadingIndicatorProvider>
                <CssBaseline/>
                <PersistGate loading={<LoadingIndicator />} persistor={persistor}>
                    <Router basename={"/"}>
                        <Suspense fallback={<LoadingIndicator />}>
                          <AppUrlListener></AppUrlListener>
                            <Switch>
                                <LoginRoute
                                    exact
                                    path="/"
                                    component={Login}
                                    LayoutProps={{
                                        noHeader: true,
                                        noFooter: true,
                                        showFloatsButtons: true
                                    }}

                                />
                                <PanelRoute
                                    exact
                                    path="/panel/:action?/:subAction?"
                                    component={Profile}
                                    LayoutProps={{
                                        noHeader: true,
                                        noFooter: true,
                                        profileHeader: true,
                                        showFloatsButtons: true
                                    }}
                                />
                                <SimpleRoute
                                    exact
                                    path="/recuperar-cuenta"
                                    component={RecoverAccount}
                                    LayoutProps={{
                                        noHeader: true,
                                        noFooter: true,
                                        showFloatsButtons : true
                                    }}
                                />
                                <SimpleRoute
                                    exact
                                    path="/registracion"
                                    component={Registration}
                                    LayoutProps={{
                                        showFloatsButtons : true
                                    }}
                                />
                                <SimpleRoute
                                    path="/registrate"
                                    component={RedirectRegistration}
                                    LayoutProps={{
                                        showFloatsButtons : true
                                    }}
                                />
                                 <SimpleRoute
                                    path="/asignacion-contrasenna"
                                    component={PasswordAssignment}
                                />
                                <Route path="*"  render={() => <Redirect to={{
                                    pathname: "/"
                                }}/>}/>
                            </Switch>
                        </Suspense>
                    </Router>
                </PersistGate>
            </LoadingIndicatorProvider>
        </ThemeProvider>
    </Provider>
};

export default App;
